


<template>
  <aside class="dashboard-sidebar-card">
    <!-- لیست منو -->
    <nav class="sidebar-nav">
      <ul class="sidebar-menu-list list-unstyled m-0 p-0">
        <!-- سفارش‌ها -->
        <li class="menu-item mb-2">
          <router-link
            :to="currentLang.urls.Order"
            class="menu-link d-flex align-items-center justify-content-between"
            active-class="active-link"
          >
            <div class="d-flex align-items-center gap-3">
              <span class="menu-icon-box">
                <i class="bi bi-bag-check"></i>
              </span>
              <span class="menu-title">{{ currentLang.orders }}</span>
            </div>
            <i class="bi bi-chevron-left arrow-icon"></i>
          </router-link>
        </li>

        <!-- آدرس‌ها -->
        <li class="menu-item mb-2">
          <router-link
            :to="currentLang.urls.Address"
            class="menu-link d-flex align-items-center justify-content-between"
            active-class="active-link"
          >
            <div class="d-flex align-items-center gap-3">
              <span class="menu-icon-box">
                <i class="bi bi-geo-alt"></i>
              </span>
              <span class="menu-title">{{ currentLang.addresses }}</span>
            </div>
            <i class="bi bi-chevron-left arrow-icon"></i>
          </router-link>
        </li>

        <!-- اطلاعات حساب کاربری -->
        <li class="menu-item mb-2">
          <router-link
          :to="currentLang.urls.Profile"
            class="menu-link d-flex align-items-center justify-content-between"
            active-class="active-link"
          >
            <div class="d-flex align-items-center gap-3">
              <span class="menu-icon-box">
                <i class="bi bi-person-gear"></i>
              </span>
              <span class="menu-title">{{ currentLang.accountInfo }}</span>
            </div>
            <i class="bi bi-chevron-left arrow-icon"></i>
          </router-link>
        </li>

        <!-- دکمه خروج -->
        <li class="menu-item mt-4 pt-3 border-top-divider">
          <button
            class="menu-link logout-link d-flex align-items-center justify-content-between w-100 border-0 bg-transparent"
            @click="handleLogout"
          >
            <div class="d-flex align-items-center gap-3">
              <span class="menu-icon-box logout-icon">
                <i class="bi bi-box-arrow-right"></i>
              </span>
              <span class="menu-title">{{ currentLang.logout }}</span>
            </div>
            <i class="bi bi-chevron-left arrow-icon"></i>
          </button>
        </li>
      </ul>
    </nav>
  </aside>
</template>






<script setup>
import { computed } from "vue";
import { lang } from "@/plugins/lang";
import enSidebar from "@/locales/en/Dashboard";
import faSidebar from "@/locales/fa/Dashboard";

const translations = {
  en: enSidebar,
  fa: faSidebar,
};

const currentLang = computed(() => translations[lang.value]);

// const emit = defineEmits(["logout"]);

const handleLogout = () => {
    localStorage.removeItem("auth_token");
  localStorage.removeItem("user_info");

  authToken.value = null;
  userInfo.value = null;
  showUserMenu.value = false;
};
</script>

<style scoped>
/* بدنه کارت سایدبار */
.dashboard-sidebar-card {
  width: 100%;
  min-height: 480px;
  padding: 24px 18px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 28px;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 18px 40px rgba(62, 77, 112, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  transition: box-shadow 0.35s ease;
}

.dashboard-sidebar-card:hover {
  box-shadow: 0 24px 50px rgba(62, 77, 112, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

/* بج بالای منو */
.sidebar-badge {
  display: inline-block;
  padding: 6px 18px;
  color: #18324b;
  font-size: 0.82rem;
  font-weight: 700;
  background: #6cceff;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 50px;
  box-shadow: 0 4px 14px rgba(108, 206, 255, 0.35);
}

/* لینک‌های منو */
.menu-link {
  padding: 12px 14px;
  border-radius: 18px;
  text-decoration: none;
  color: #68748b;
  font-weight: 600;
  font-size: 0.92rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.menu-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.9);
  color: #18325b;
  font-size: 1.15rem;
  box-shadow: 0 4px 10px rgba(62, 77, 112, 0.06);
  transition: all 0.3s ease;
}

.arrow-icon {
  font-size: 0.75rem;
  opacity: 0.5;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* حالت هوور لینک */
.menu-link:hover {
  background: rgba(255, 255, 255, 0.75);
  color: #18325b;
  box-shadow: 0 6px 18px rgba(62, 77, 112, 0.08);
  transform: translateY(-2px);
}

.menu-link:hover .menu-icon-box {
  background: #ffffff;
  box-shadow: 0 6px 14px rgba(62, 77, 112, 0.12);
}

.menu-link:hover .arrow-icon {
  opacity: 1;
  transform: translateX(-3px);
}

/* لینک فعال (Active) */
.active-link {
  background: linear-gradient(135deg, #6cceff, #9edcff) !important;
  color: #18325b !important;
  font-weight: 800;
  box-shadow: 0 8px 22px rgba(108, 206, 255, 0.4) !important;
}

.active-link .menu-icon-box {
  background: #ffffff;
  color: #18325b;
}

.active-link .arrow-icon {
  opacity: 1;
  color: #18325b;
}

/* خط جداکننده */
.border-top-divider {
  border-top: 1px dashed rgba(104, 116, 139, 0.25);
}

/* استایل خروج */
.logout-link {
  color: #e05368;
}

.logout-icon {
  color: #e05368;
}

.logout-link:hover {
  background: rgba(224, 83, 104, 0.12);
  color: #c93b51;
}

.logout-link:hover .logout-icon {
  background: #ffffff;
  color: #c93b51;
}
</style>
